// Shared full-text search helpers for long-form structured document readers.

const blockSearchText = (block = {}) => {
  const values = [];

  if (block.text) values.push(block.text);

  if (Array.isArray(block.items)) {
    block.items.forEach((item) => {
      if (typeof item === 'string') {
        values.push(item);
      } else if (item) {
        values.push(item.label || '', item.text || '');
      }
    });
  }

  if (block.t === 'table') {
    (block.headers || []).forEach((header) => {
      values.push(typeof header === 'string' ? header : header?.text || '');
    });
    (block.rows || []).forEach((row) => values.push(...row));
  }

  return values.join(' ');
};

export const getDocumentSectionSearchText = (section = {}) => (
  [
    section.number,
    section.title,
    section.summary,
    ...(section.blocks || []).map(blockSearchText),
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase()
);

export const filterDocumentSections = (sections = [], query = '') => {
  const normalizedQuery = query.trim().toLowerCase();
  if (!normalizedQuery) return sections;

  return sections.filter(
    (section) => getDocumentSectionSearchText(section).includes(normalizedQuery),
  );
};

